import { memo } from 'react'

import config from 'config'
import { SubAppRouteConfig } from 'types/SubAppRouteConfig'
import ModuleFederationLoader from 'utils/ModuleFederationLoader'

const DialPlanRoutesComponent = memo(() => (
  <ModuleFederationLoader
    module="dialPlanApp"
    subAppModuleFederation={config.subAppsModuleFederation.uccUnifiedAdminDial}
    key="dialPlanApp"
  />
))

const useDialPlanRoutes = (path: string): SubAppRouteConfig => {
  return {
    paths: config.subAppsModuleFederation.uccUnifiedAdminDial.routes?.map((route) => `${path}/${route}`) ?? [],
    component: () => <DialPlanRoutesComponent />,
  }
}

export default useDialPlanRoutes
